// extracted by mini-css-extract-plugin
export default {"patientsGrid":"style_patientsGrid__xzJBc","tabs":"style_tabs__Ur-IU","sel":"style_sel__K+a8s","charts":"style_charts__oKdKo","chart":"style_chart__Uy4nq"};